import React from 'react';
import Responsive from 'react-responsive';
import { OLD_MOBILE_BREAKPOINT_MAX } from '../../../config/consts';

const OldMobile = props => <Responsive {...props} maxWidth={OLD_MOBILE_BREAKPOINT_MAX} />;

export default OldMobile;
